// SemiconductorLayout.jsx


import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
import { Helmet } from "react-helmet";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";
// SemiconductorLayout.jsx

const SemiconductorLayout = () => {
  
 const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  return (
    <div className="service-page">

      <Helmet>
        <title>
          Semiconductor Integrated Circuit Layout Design Registration
        </title>

        <meta
          name="description"
          content="Protect semiconductor chip layout designs with Semiconductor Integrated Circuit Layout Design Registration in India. Secure legal rights for your original IC designs."
        />

        <meta
          name="keywords"
          content="Semiconductor Layout Registration, IC Layout Design Registration, Chip Design Protection, Semiconductor Registration India"
        />
      </Helmet>

      {/* HERO */}
      <section className="service-hero">
        <h1>Semiconductor Integrated Circuit Layout Design Registration</h1>

        <p>
          Protect Your Original Chip & Integrated Circuit Layout Designs Legally
        </p>
         <button className="hero-btn" onClick={scrollToContact}>
                        Get Started Today
                    </button>
      </section>

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>

        <div className="card">
          <p>
            Semiconductor Integrated Circuit Layout Design Registration protects
            the unique layout and design structure of semiconductor chips and
            integrated circuits (ICs).
          </p>

          <p>
            It grants exclusive legal rights over the original layout design and
            prevents unauthorized copying, reproduction, or commercial use.
          </p>
        </div>
      </section>

      {/* WHAT IT PROTECTS */}
      <section className="service-section">
        <h2>What Does It Protect?</h2>

        <div className="service-grid-box">

          <div className="card">
            Semiconductor Chip Layouts
          </div>

          <div className="card">
            Integrated Circuit (IC) Designs
          </div>

          <div className="card">
            Electronic Circuit Patterns
          </div>

          <div className="card">
            Microchip Configuration Designs
          </div>

          <div className="card">
            Original Circuit Layout Structures
          </div>

          <div className="card">
            Semiconductor Topography Designs
          </div>

        </div>
      </section>

      {/* BENEFITS */}
      <section className="service-section">
        <h2>Benefits of Registration</h2>

        <div className="service-grid-box">

          <div className="card">
            ✔ Legal protection for chip designs
          </div>

          <div className="card">
            ✔ Prevents unauthorized copying
          </div>

          <div className="card">
            ✔ Exclusive commercial rights
          </div>

          <div className="card">
            ✔ Enhances technology value
          </div>

          <div className="card">
            ✔ Supports innovation protection
          </div>

          <div className="card">
            ✔ Improves market credibility
          </div>

        </div>
      </section>

      {/* VALIDITY */}
      <section className="service-section">
        <h2>Validity of Registration</h2>

        <div className="card">
          <p>
            Semiconductor Integrated Circuit Layout Design registration remains
            valid for <strong>10 years</strong> from the date of filing or first
            commercial exploitation, whichever is earlier.
          </p>
        </div>
      </section>

      {/* WHO SHOULD APPLY */}
      <section className="service-section">
        <h2>Who Should Apply?</h2>

        <div className="service-grid-box">

          <div className="card">
            Semiconductor Companies
          </div>

          <div className="card">
            Electronics Manufacturers
          </div>

          <div className="card">
            Chip Designers
          </div>

          <div className="card">
            Technology Startups
          </div>

          <div className="card">
            Hardware Developers
          </div>

          <div className="card">
            Research Organizations
          </div>

        </div>
      </section>

      {/* DOCUMENTS */}
      <section className="service-section">
        <h2>Documents Required</h2>

        <div className="service-grid-box">

          <div className="card">
            Applicant Identity Proof
          </div>

          <div className="card">
            Address Proof
          </div>

          <div className="card">
            Layout Design Drawings
          </div>

          <div className="card">
            Technical Description
          </div>

          <div className="card">
            Business Registration Proof
          </div>

          <div className="card">
            Declaration of Originality
          </div>

        </div>
      </section>

      {/* PROCESS */}
      <section className="service-section">
        <h2>Registration Process</h2>

        <div className="service-grid-box">

          <div className="card">
            Design Review & Consultation
          </div>

          <div className="card">
            Documentation Preparation
          </div>

          <div className="card">
            Application Filing
          </div>

          <div className="card">
            Examination by Authority
          </div>

          <div className="card">
            Objection Handling (if any)
          </div>

          <div className="card">
            Registration Certificate Issuance
          </div>

        </div>
      </section>

      {/* SERVICES */}
      <section className="service-section">
        <h2>Our Services Include</h2>

        <div className="card">
          <ul>
            <li>Layout design consultation</li>
            <li>Application drafting & filing</li>
            <li>Technical documentation support</li>
            <li>Compliance & examination assistance</li>
            <li>End-to-end registration support</li>
            <li>Renewal & legal guidance</li>
          </ul>
        </div>
      </section>

      {/* WHY CHOOSE US */}
      <section className="service-section">
        <h2>Why Choose Us?</h2>

        <div className="card">
          <ul>
            <li>✔ Experienced IPR professionals</li>
            <li>✔ Strong technical documentation support</li>
            <li>✔ Quick & smooth filing process</li>
            <li>✔ Affordable pricing</li>
            <li>✔ End-to-end assistance</li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Protect Your Semiconductor Innovations</h2>

        <p>
          Secure legal rights over your original chip and IC layout designs with
          professional registration support.
        </p>

        <button>Apply Now</button>
      </section> */}

      
         <div className="cta" ref={contactRef}>
                 <h2>Protect Your Semiconductor Innovations</h2>
               <p>
          Secure legal rights over your original chip and IC layout designs with
          professional registration support.
        </p>
              <div className="cta-buttons">
                <button onClick={() => setOpenPopup(true)}>Apply Now</button>
                <ContactPopup
                  isOpen={openPopup}
                  onClose={() => setOpenPopup(false)}
                />
      
                <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
              </div>
            </div>


    </div>
  );
};

export default SemiconductorLayout;